import { colors } from '../common/colors';
import { palette as defaultPalette } from '../common/palette';

export const secondary = {
    main: colors.themes.blue.primary,
    contrastText: colors.black,
};

export const common = {
    ...colors,
    ...colors.themes.blue,
};

export const palette = {
    ...defaultPalette,
    secondary,
    common,
    action: {
        active: colors.themes.blue.primaryLightSelected,
        hover: colors.themes.blue.primaryLightHover,
        selected: colors.themes.blue.primaryLightSelected,
        focus: colors.themes.blue.primaryLightSelected,
    },
};
